<template>
  <div class="open-positions-card">
    <NuxtLink :to="ctaLink">
      <GenericCard
        :key="item.id"
        :cta-link="ctaLink"
        :custom-element-content="item.shortDescription"
        :department="item.department"
        :location="getLocation(item)"
        :title="item.title"
        cta-label="Apply"
      >
        <template #ctaLeft>
          <span class="job-number">Job Req. #: {{ item?.jobNumber }}</span>
        </template>
      </GenericCard>
    </NuxtLink>
  </div>
</template>
<script lang="ts" setup>
import type { SearchResultOpenPositionItem } from '~/types/SearchResultItem'
import type { LocationPageModel } from '~/models'

const pageStore = usePageStore()

const props = defineProps<{
  item: SearchResultOpenPositionItem
  locations: LocationPageModel[] | undefined
}>()

const ctaLink = ref<string>('')
if (props.item.type === 'greenhouse-job-post') {
  ctaLink.value = props.item.urlSlug
} else {
  pageStore.getUrlByItemId(props.item.id).then((url) => {
    if (url) ctaLink.value = url
  })
}

const getLocation = computed(() => (item: SearchResultOpenPositionItem) => {
  const codes = (item.location ?? '').split(';')

  const locations = codes.map((code: string) =>
    props.locations?.find((loc: LocationPageModel) => loc.system.codename === code)
  )
  return locations.length > 1 ? 'Multiple' : (locations[0]?.elements?.title?.value ?? '')
})
</script>
